import React, { useEffect, useState } from "react";
import addIcon from "../../../../../Assets/images/add-plus.svg";
import JobTableSection from "../../Components/JobsItems/JobsList/JobsList";
import ViewJobModal from "../../Components/JobsItems/ViewJobModal/ViewJobModal";
import "./Jobs.scss";
import apiClient from "../../../../../Config/apiClient";
import { hasPermission } from "../../Services/permission";

const jobsBaseUrl = process.env.REACT_APP_HS_JOBS_BASE_PATH;

const JOB_SECTION = "jobs";
const JOB_EDIT_KEY = ["jobs_edit"];

const JobsPage = () => {
  const [startingJobs, setStartingJobs] = useState([]);
  const [progressJobs, setProgressJobs] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(false);

  const [jobsPerPage, setJobsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [filtersData, setFiltersData] = useState({
    starting: {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    },
    progress: {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    },
    all: {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    },
  });

  const [jobData, setJobData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const canEditJobs = hasPermission({ section: JOB_SECTION, keys: JOB_EDIT_KEY, });

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);

        const [allRes] = await Promise.all([
          apiClient.get(`${jobsBaseUrl}/`),
        ]);
        
        setAllJobs(allRes.data.data || []);
      } catch (err) {
        console.error("Error fetching jobs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, [refresh]);

  const getJobsForActiveTab = () => {
    switch (activeTab) {
      case "starting":
        return startingJobs;
      case "progress":
        return progressJobs;
      case "all":
        return allJobs;
      default:
        return [];
    }
  };

  const totalJobs = getJobsForActiveTab().filter((job) =>
    (job.job_name && job.job_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (job.job_description && job.job_description.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (job.job_type && job.job_type.toLowerCase().includes(searchTerm.toLowerCase()))
  ).length;
  const startIndex = (currentPage - 1) * jobsPerPage;

  const handleFilterChange = async (newFilters) => {
    setFiltersData((prev) => ({
      ...prev,
      [activeTab]: newFilters,
    }));
    setCurrentPage(1);

    try {
      setLoading(true);

      let apiUrl = "";
      switch (activeTab) {
        case "starting":
          apiUrl = `${jobsBaseUrl}/starting-today`;
          break;
        case "progress":
          apiUrl = `${jobsBaseUrl}/in-progress`;
          break;
        case "all":
          apiUrl = `${jobsBaseUrl}/`;
          break;
      }

      const response = await apiClient.get(apiUrl, {
        params: newFilters,
      });

      if (activeTab === "starting") setStartingJobs(response.data.data || []);
      if (activeTab === "progress") setProgressJobs(response.data.data || []);
      if (activeTab === "all") setAllJobs(response.data.data || []);
    } catch (err) {
      console.error("Error applying filters:", err);
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = async () => {
    const defaultFilters = {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    };

    setFiltersData((prev) => ({
      ...prev,
      [activeTab]: defaultFilters,
    }));

    setCurrentPage(1);

    try {
      setLoading(true);

      let apiUrl = "";
      switch (activeTab) {
        case "starting":
          apiUrl = `${jobsBaseUrl}/starting-today`;
          break;
        case "progress":
          apiUrl = `${jobsBaseUrl}/in-progress`;
          break;
        case "all":
          apiUrl = `${jobsBaseUrl}/`;
          break;
      }

      const response = await apiClient.get(apiUrl);

      if (activeTab === "starting") setStartingJobs(response.data.data || []);
      if (activeTab === "progress") setProgressJobs(response.data.data || []);
      if (activeTab === "all") setAllJobs(response.data.data || []);
    } catch (err) {
      console.error("Error resetting filters:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleStatusChange = (newStatus) => {
    setRefresh(prev => !prev);
  };

  return (
    <main className="full-wraper">
      <div className="main-wraper">
        <div className="container-fluid">
          <div className="main-inner">
            <JobTableSection
              jobs={getJobsForActiveTab()}
              jobsPerPage={jobsPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              setJobsPerPage={setJobsPerPage}
              totalJobs={totalJobs}
              startIndex={startIndex}
              onSearchChange={setSearchTerm}
              searchTerm={searchTerm}
              setJobData={setJobData}
              setShowModal={setShowModal}
              filters={filtersData[activeTab]}
              onFilterChange={handleFilterChange}
              resetFilters={resetFilters}
              loading={loading}
              setRefresh={setRefresh}
              canEditJobs={canEditJobs}
            />
          </div>
        </div>
      </div>
 
      <ViewJobModal jobId={jobData?.id} refresh={() => setRefresh(prev => !prev)} onStatusChange={handleStatusChange} />
    </main>
  );
};

export default JobsPage;
